function LicenciaCardSkeleton() {
  return (
    <div>
      <div className="flex overflow-hidden items-center bg-white border border-[#C5E0FF] gap-1 pr-1 p-3 rounded-lg shadow-[1px_2px_8px_1px_rgba(219,219,219,0.45)] flex-row md:max-w-xl animate-pulse">
        {/* Imagen */}
        <div className="w-full md:w-1/2 h-48 bg-gray-200 rounded" />

        {/* Contenido */}
        <div className="flex flex-col justify-between px-2 leading-normal gap-3 w-full">
          <div className="space-y-2">
            <div className="h-4 w-3/4 bg-gray-200 rounded" />
            <div className="h-4 w-full bg-gray-200 rounded" />
            <div className="h-4 w-full bg-gray-200 rounded" />
            <div className="h-4 w-2/3 bg-gray-200 rounded" />
          </div>

          {/* Botón */}
          <div className="flex justify-end">
            <div className="w-24 h-8 bg-gray-200 rounded-lg" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default LicenciaCardSkeleton;